import { app } from "modular-openscriptjs";
import OffcanvasComponent from "../OffcanvasComponent";

const h = app("h");

export default class ViewProductCanvas extends OffcanvasComponent {
    name = "ViewProductCanvas";
    
    render(...args) {
        return h.$(h.div({ class: "offcanvas-body" }, ...args));
    }
}
